(() => {
  if (!customElements.get('video-page-player')) {
    class VideoPagePlayer extends HTMLElement {
      constructor() {
        super();
        this.onPlay = this.onPlay.bind(this);
        this.onPause = this.onPause.bind(this);
        this.handlePlayClick = this.handlePlayClick.bind(this);
        this.handlePauseClick = this.handlePauseClick.bind(this);
        this.hasPlayedOnce = false;
        this.playedOnMobile = false;
        this.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        this.isHovered = false;
      }

      setButtonState() {
        if (this.type === 'shopify') {
          const isPlaying = this.video && !this.video.paused;
          if (this.isTouch) {
            if (!this.playedOnMobile) {
              this.playBtn && (this.playBtn.style.display = 'flex');
            } else {
              this.playBtn && (this.playBtn.style.display = 'none');
            }

            this.pauseBtn && (this.pauseBtn.style.display = 'none');
          } else {
            if (!this.playedOnMobile && !isPlaying) {
              this.playBtn && (this.playBtn.style.display = 'flex');
              this.pauseBtn && (this.pauseBtn.style.display = 'none');
            } else {
              this.playBtn && (this.playBtn.style.display = 'none');
              this.pauseBtn && (this.pauseBtn.style.display = 'none');
            }
          }
        }

        if (this.type === 'youtube') {
          this.playBtn && (this.playBtn.hidden = this.hasPlayedOnce);
          this.pauseBtn && (this.pauseBtn.hidden = true);
        }
      }

      connectedCallback() {
        this.type = this.dataset.type;
        this.playBtn = this.querySelector('[data-video-page-play]');
        this.pauseBtn = this.querySelector('[data-video-page-pause]');
        this.poster = this.querySelector('.video-card__poster');
        this.iframeWrapper = this.querySelector('.video-card__iframe-wrapper');
        this.card = this.closest('.video-card');

        if (this.type === 'shopify') {
          this.video = this.querySelector('video');
          if (this.video) {
            this.video.addEventListener('play', this.onPlay);
            this.video.addEventListener('pause', this.onPause);
          }
        }

        this.playBtn && this.playBtn.addEventListener('click', this.handlePlayClick);
        this.pauseBtn && this.pauseBtn.addEventListener('click', this.handlePauseClick);

        if (!this.isTouch && this.card) {
          this.card.addEventListener('mouseenter', () => {
            this.isHovered = true;
            this.setButtonState();
          });
          this.card.addEventListener('mouseleave', () => {
            this.isHovered = false;
            this.setButtonState();
          });
        }

        this.setButtonState();
      }

      disconnectedCallback() {
        if (this.type === 'shopify' && this.video) {
          this.video.removeEventListener('play', this.onPlay);
          this.video.removeEventListener('pause', this.onPause);
        }
        this.playBtn && this.playBtn.removeEventListener('click', this.handlePlayClick);
        this.pauseBtn && this.pauseBtn.removeEventListener('click', this.handlePauseClick);
      }

      pauseAllExcept(currentPlayer) {
        document.querySelectorAll('video-page-player').forEach(player => {
          if (player === currentPlayer) return;

          if (player.type === 'shopify' && player.video && !player.video.paused) {
            try { player.video.pause(); } catch(e) {}
            player.card && player.card.classList.remove('is-playing');
          }

          if (player.type === 'youtube' && player.iframe?.contentWindow) {
            player.iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
              '*'
            );
            player.card && player.card.classList.remove('is-playing');
          }

          player.setButtonState();
        });
      }

      onPlay() {
        this.hasPlayedOnce = true;
        if (this.isTouch) this.playedOnMobile = true;
        this.card && this.card.classList.add('is-playing');
        this.poster && (this.poster.hidden = true);
        this.pauseAllExcept(this);
        this.setButtonState();
      }

      onPause() {
        this.card && this.card.classList.remove('is-playing');
        this.setButtonState();
      }

      handlePlayClick(e) {
        e.preventDefault();

        if (this.isTouch) {
          this.playedOnMobile = true;
          this.card?.classList.add('video-card--played');
        }

        if (this.type === 'shopify') {
          this.pauseAllExcept(this);
          this.video?.play();
          return;
        }

        if (this.type === 'youtube') {
          const youtubeId = this.dataset.youtubeId;
          if (!youtubeId || !this.iframeWrapper) return;

          let iframe = this.iframeWrapper.querySelector('iframe');
          this.pauseAllExcept(this);

          if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.src = `https://www.youtube.com/embed/${youtubeId}?enablejsapi=1&rel=0&autoplay=1`;
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute(
              'allow',
              'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            );
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('loading', 'lazy');
            iframe.setAttribute('title', this.querySelector('img')?.alt || 'YouTube video');

            this.iframeWrapper.innerHTML = '';
            this.iframeWrapper.appendChild(iframe);
            this.iframeWrapper.hidden = false;
            this.iframe = iframe;

            iframe.addEventListener('load', () => {
              this.pauseAllExcept(this);
            });
          } else if (iframe.contentWindow) {
            iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'playVideo', args: [] }),
              '*'
            );
            setTimeout(() => {
              this.pauseAllExcept(this);
            }, 50);
          }

          this.hasPlayedOnce = true;
          this.poster && (this.poster.hidden = true);
          this.card && this.card.classList.add('is-playing');
          this.setButtonState();
        }
      }

      handlePauseClick(e) {
        e.preventDefault();
        if (this.type === 'shopify') {
          this.video?.pause();
        } else if (this.type === 'youtube' && this.iframe?.contentWindow) {
          this.iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
            '*'
          );
          this.card && this.card.classList.remove('is-playing');
        }
      }
    }

    customElements.define('video-page-player', VideoPagePlayer);
  }

  const getClampLines = (el) => {
    const raw = getComputedStyle(el).getPropertyValue('--vp-line-clamp').trim();
    const parsed = parseInt(raw, 10);
    return isNaN(parsed) ? 3 : parsed;
  };

  const measureFullHeight = (descText, card) => {
    const clone = descText.cloneNode(true);

    clone.style.cssText = `
      display: block !important;
      -webkit-line-clamp: unset !important;
      line-clamp: unset !important;
      -webkit-box-orient: unset !important;
      overflow: visible !important;
      position: absolute !important;
      visibility: hidden !important;
      pointer-events: none !important;
      top: -9999px !important;
      left: 0 !important;
      width: ${descText.getBoundingClientRect().width}px !important;
      height: auto !important;
      max-height: none !important;
      white-space: normal !important;
    `;

    card.appendChild(clone);
    const fullHeight = clone.scrollHeight;
    card.removeChild(clone);

    return fullHeight;
  };

  const initReadMore = sectionEl => {
    const buttons = sectionEl.querySelectorAll('[data-video-page-read-more]');
    const readMoreText = sectionEl.dataset.readMoreText;
    const readLessText = sectionEl.dataset.readLessText;

    buttons.forEach(btn => {
      if (btn.dataset.readMoreInit) return;
      btn.dataset.readMoreInit = 'true';

      const card = btn.closest('[data-video-page-card]');
      if (!card) return;

      const descWrap = card.querySelector('[data-video-page-desc]');
      const descText = card.querySelector('.video-page__video-desc-text');

      if (!descWrap || !descText) return;

      const checkOverflow = () => {
        const computedStyle = getComputedStyle(descText);
        let lineHeight = parseFloat(computedStyle.lineHeight);

        if (isNaN(lineHeight)) {
          lineHeight = parseFloat(computedStyle.fontSize) * 1.6;
        }

        const clampLines = getClampLines(descWrap);

        const fullHeight = measureFullHeight(descText, card);

        const totalLines = fullHeight / lineHeight;
        const needsClamp = totalLines > clampLines + 0.5;

        if (!needsClamp) {
          btn.style.display = 'none';
          descWrap.classList.remove('video-page__video-desc--clamped');
          descWrap.classList.add('video-page__video-desc--no-read-more');
        } else {
          btn.style.display = 'inline-block';
          if (btn.getAttribute('aria-expanded') !== 'true') {
            descWrap.classList.add('video-page__video-desc--clamped');
            descWrap.classList.remove('video-page__video-desc--no-read-more');
          }
        }
      };

      checkOverflow();

      if (window.ResizeObserver) {
        const ro = new ResizeObserver(() => checkOverflow());
        ro.observe(descText);
        btn._resizeObserver = ro;
      } else {
        window.addEventListener('resize', checkOverflow);
      }

      btn.addEventListener('click', () => {
        const isClamped = descWrap.classList.contains('video-page__video-desc--clamped');
        if (isClamped) {
          descWrap.classList.remove('video-page__video-desc--clamped');
          btn.setAttribute('aria-expanded', 'true');
          btn.querySelector('[data-read-more-label]').textContent = readLessText;
        } else {
          descWrap.classList.add('video-page__video-desc--clamped');
          btn.setAttribute('aria-expanded', 'false');
          btn.querySelector('[data-read-more-label]').textContent = readMoreText;
        }
      });
    });
  };

  document.querySelectorAll('[data-video-page-section]').forEach(initReadMore);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-video-page-section]');
    if (section) initReadMore(section);
  });
})();
